var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item md-size-100 md-small-size-100"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('DeviceCreateCard')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }